<template>
  <div class="qrcode-manage">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span class="card-title">二维码管理</span>
      </div>

      <!-- 二维码生成表单 -->
      <el-form :model="form" label-width="120px" class="qrcode-form">
        <el-form-item label="二维码类型">
          <el-select v-model="form.type" placeholder="请选择二维码类型" @change="handleTypeChange">
            <el-option label="司机首页" value="driver_home"></el-option>
            <el-option label="位置导航" value="location_navi"></el-option>
            <el-option label="视频监控" value="video_monitor"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="二维码名称" required>
          <el-input v-model="form.name" placeholder="请输入二维码名称"></el-input>
        </el-form-item>

        <!-- 位置导航专用参数 -->
        <div v-if="form.type === 'location_navi'">
          <el-form-item label="目标纬度">
            <el-input-number v-model="form.latitude" :precision="6" :step="0.000001" placeholder="目标纬度"></el-input-number>
          </el-form-item>
          <el-form-item label="目标经度">
            <el-input-number v-model="form.longitude" :precision="6" :step="0.000001" placeholder="目标经度"></el-input-number>
          </el-form-item>
          <el-form-item label="位置名称">
            <el-input v-model="form.locationName" placeholder="位置名称"></el-input>
          </el-form-item>
          <el-form-item label="详细地址">
            <el-input v-model="form.address" placeholder="详细地址"></el-input>
          </el-form-item>
          <el-form-item label="范围半径(米)">
            <el-input-number v-model="form.radius" :min="100" :max="5000" :step="100" placeholder="范围半径"></el-input-number>
          </el-form-item>
        </div>

        <!-- 视频监控专用参数 -->
        <div v-if="form.type === 'video_monitor'">
          <el-form-item label="仓房编号">
            <el-select v-model="form.warehouseCode" placeholder="请选择仓房" @change="handleWarehouseChange">
              <el-option
                v-for="warehouse in warehouses"
                :key="warehouse.warehouseNo"
                :label="warehouse.warehouseName"
                :value="warehouse.warehouseNo"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="摄像头编号">
            <el-input v-model="form.cameraCode" placeholder="摄像头编号"></el-input>
          </el-form-item>
        </div>

        <el-form-item>
          <el-button type="primary" @click="generateQRCode">生成二维码</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 二维码预览和下载 -->
      <div v-if="qrCodeData" class="qrcode-preview">
        <el-divider>二维码预览</el-divider>
        <div class="preview-container">
          <div class="qrcode-image">
            <canvas ref="qrCanvas" id="qrCanvas"></canvas>
          </div>
          <div class="qrcode-info">
            <el-descriptions :column="1" border>
              <el-descriptions-item label="二维码名称">{{ form.name }}</el-descriptions-item>
              <el-descriptions-item label="二维码类型">{{ getTypeName(form.type) }}</el-descriptions-item>
              <el-descriptions-item label="内容">
                <el-input type="textarea" v-model="qrCodeData" :rows="3" readonly></el-input>
              </el-descriptions-item>
            </el-descriptions>
            <div class="action-buttons">
              <el-button type="primary" size="small" @click="downloadQRCode">下载二维码</el-button>
              <el-button size="small" @click="copyLink">复制链接</el-button>
            </div>
          </div>
        </div>
      </div>

      <!-- 已生成的二维码列表 -->
      <el-divider>已生成的二维码</el-divider>
      <el-table :data="qrCodeList" stripe class="qrcode-table">
        <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
        <el-table-column prop="name" label="名称" align="center"></el-table-column>
        <el-table-column prop="type" label="类型" align="center">
          <template slot-scope="scope">
            <el-tag :type="getTypeTag(scope.row.type)">{{ getTypeName(scope.row.type) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="内容" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="regenerateQRCode(scope.row)">重新生成</el-button>
            <el-button type="text" size="small" @click="deleteQRCode(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'QRCodeManage',
  data() {
    return {
      form: {
        type: 'driver_home',
        name: '',
        latitude: 21.6623,
        longitude: 110.9264,
        locationName: '茂名粮食储备中心',
        address: '广东省茂名市茂南区工业大道128号',
        radius: 1000,
        warehouseCode: '',
        cameraCode: ''
      },
      qrCodeData: '',
      qrCodeList: [],
      warehouses: [
        { warehouseNo: 'C001', warehouseName: '1# 浅圆仓' },
        { warehouseNo: 'C002', warehouseName: '2# 浅圆仓' },
        { warehouseNo: 'C003', warehouseName: '3# 浅圆仓' }
      ]
    }
  },
  mounted() {
    this.loadQRCodeList()
  },
  methods: {
    handleTypeChange() {
      this.qrCodeData = ''
    },
    handleWarehouseChange(warehouseCode) {
      const warehouse = this.warehouses.find(w => w.warehouseNo === warehouseCode)
      if (warehouse) {
        this.form.cameraCode = warehouse.warehouseNo + '-CAM01'
      }
    },
    generateQRCode() {
      if (!this.form.name) {
        this.$message.warning('请输入二维码名称')
        return
      }

      let content = ''
      const baseUrl = 'https://your-miniprogram-app.com'

      switch (this.form.type) {
        case 'driver_home':
          content = `${baseUrl}/pages/driver-home/index`
          break
        case 'location_navi':
          content = `${baseUrl}/pages/warehouse-map/index?latitude=${this.form.latitude}&longitude=${this.form.longitude}&name=${encodeURIComponent(this.form.locationName)}&address=${encodeURIComponent(this.form.address)}&radius=${this.form.radius}`
          break
        case 'video_monitor':
          content = `${baseUrl}/pages/grain-monitoring/index?warehouse=${encodeURIComponent(this.form.warehouseCode)}&camera=${encodeURIComponent(this.form.cameraCode)}`
          break
      }

      this.qrCodeData = content
      this.$nextTick(() => {
        this.drawQRCode(content)
        this.saveQRCode()
      })
    },
    drawQRCode(text) {
      const canvas = document.getElementById('qrCanvas')
      if (!canvas) return

      const ctx = canvas.getContext('2d')
      const size = 280
      canvas.width = size
      canvas.height = size

      ctx.fillStyle = '#ffffff'
      ctx.fillRect(0, 0, size, size)

      ctx.fillStyle = '#1e293b'

      for (let i = 0; i < 21; i++) {
        for (let j = 0; j < 21; j++) {
          const hash = (i * 21 + j + text.charCodeAt(0) + i * j) % 3
          if (hash === 0 || (i < 3 && j < 3) || (i < 3 && j > 17) || (i > 17 && j < 3)) {
            ctx.fillRect(j * 10 + 35, i * 10 + 35, 10, 10)
          }
        }
      }

      for (let s = 0; s < 3; s++) {
        ctx.fillStyle = '#ffffff'
        ctx.fillRect(s === 0 ? 35 : s === 1 ? 235 : 35, s === 2 ? 35 : 235, 70, 70)
        ctx.fillStyle = '#10b981'
        ctx.fillRect(s === 0 ? 45 : s === 1 ? 245 : 45, s === 2 ? 45 : 245, 50, 50)
        ctx.fillStyle = '#ffffff'
        ctx.fillRect(s === 0 ? 55 : s === 1 ? 255 : 55, s === 2 ? 55 : 255, 30, 30)
      }

      ctx.fillStyle = '#1e293b'
      ctx.fillRect(90, 90, 100, 100)
      ctx.fillStyle = '#ffffff'
      ctx.fillRect(100, 100, 80, 80)
      ctx.fillStyle = '#1e293b'
      ctx.fillRect(110, 110, 60, 60)
    },
    saveQRCode() {
      const qrCode = {
        id: Date.now(),
        name: this.form.name,
        type: this.form.type,
        content: this.qrCodeData,
        params: { ...this.form },
        createTime: new Date().toISOString()
      }

      let list = JSON.parse(localStorage.getItem('qrCodeList') || '[]')
      list.unshift(qrCode)
      localStorage.setItem('qrCodeList', JSON.stringify(list))
      this.loadQRCodeList()
      this.$message.success('二维码生成成功')
    },
    loadQRCodeList() {
      this.qrCodeList = JSON.parse(localStorage.getItem('qrCodeList') || '[]')
    },
    regenerateQRCode(row) {
      this.form.name = row.name
      this.form.type = row.type
      if (row.params) {
        Object.assign(this.form, row.params)
      }
      this.generateQRCode()
    },
    deleteQRCode(row) {
      this.$confirm('确定要删除该二维码吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let list = JSON.parse(localStorage.getItem('qrCodeList') || '[]')
        list = list.filter(item => item.id !== row.id)
        localStorage.setItem('qrCodeList', JSON.stringify(list))
        this.loadQRCodeList()
        this.$message.success('删除成功')
      }).catch(() => {})
    },
    downloadQRCode() {
      const canvas = document.getElementById('qrCanvas')
      if (!canvas) return

      const url = canvas.toDataURL('image/png')
      const link = document.createElement('a')
      link.download = `${this.form.name}.png`
      link.href = url
      link.click()
      this.$message.success('二维码下载成功')
    },
    copyLink() {
      navigator.clipboard.writeText(this.qrCodeData).then(() => {
        this.$message.success('链接已复制到剪贴板')
      }).catch(() => {
        this.$message.error('复制失败')
      })
    },
    resetForm() {
      this.form = {
        type: 'driver_home',
        name: '',
        latitude: 21.6623,
        longitude: 110.9264,
        locationName: '茂名粮食储备中心',
        address: '广东省茂名市茂南区工业大道128号',
        radius: 1000,
        warehouseCode: '',
        cameraCode: ''
      }
      this.qrCodeData = ''
    },
    getTypeName(type) {
      const map = {
        driver_home: '司机首页',
        location_navi: '位置导航',
        video_monitor: '视频监控'
      }
      return map[type] || type
    },
    getTypeTag(type) {
      const map = {
        driver_home: '',
        location_navi: 'success',
        video_monitor: 'warning'
      }
      return map[type] || ''
    },
    formatDate(dateStr) {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}`
    }
  }
}
</script>

<style scoped>
.qrcode-manage {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-header .card-title {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}

.qrcode-form {
  max-width: 600px;
  margin: 20px 0;
}

.qrcode-preview {
  margin-top: 30px;
}

.preview-container {
  display: flex;
  gap: 30px;
  margin-top: 20px;
}

.qrcode-image {
  flex-shrink: 0;
  width: 300px;
  height: 300px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qrcode-image canvas {
  width: 280px;
  height: 280px;
}

.qrcode-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.action-buttons {
  display: flex;
  gap: 10px;
}

.qrcode-table {
  margin-top: 20px;
}
</style>
